/**
 * Zugriff der Feldbausteine auf Modell und View — Pendant zu `@bind-Value=Model.Feld`
 * zusammen mit `GetField(nameof(...))` aus `IwmFormContainer.razor`.
 *
 * Die Rohwerte sind `unknown`, weil ein Baustein für alle Felder desselben Editortyps
 * gilt; die Umwandlung in den Editor-Typ übernehmen die Helfer unten.
 */

import type { ChinaAppSysViewField } from '@/types/entities';
import { parseApiDate } from '@/utils/date';

export interface FieldAccess<T> {
  value: (name: keyof T & string) => unknown;
  setValue: (name: keyof T & string, value: unknown) => void;
  /** `null`, wenn das Feld nicht in `view.Fields` steht — dann wird es nicht gerendert. */
  viewField: (name: keyof T & string) => ChinaAppSysViewField | null;
  /** Validierungsmeldung des Feldes oder `undefined`. */
  message: (name: keyof T & string) => string | undefined;
}

export function asText(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

export function asNumber(value: unknown): number | null {
  return typeof value === 'number' ? value : null;
}

export function asFlag(value: unknown): boolean | null {
  return typeof value === 'boolean' ? value : null;
}

/** Datumswerte kommen als ISO-Zeichenkette aus der API (REQ-00 §7). */
export function asDate(value: unknown): Date | null {
  return parseApiDate(asText(value));
}

/** Umkehrung von {@link asDate} — die API erwartet wieder eine ISO-Zeichenkette. */
export function fromDate(value: Date | null): string | null {
  return value === null ? null : value.toISOString();
}
